import { render, staticRenderFns } from "./VxTabs.vue?vue&type=template&id=588a1c94&lang=html"
import script from "./VxTabs.vue?vue&type=script&lang=js"
export * from "./VxTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/alquant/white-label-platforms/platform-ais/platform/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588a1c94')) {
      api.createRecord('588a1c94', component.options)
    } else {
      api.reload('588a1c94', component.options)
    }
    module.hot.accept("./VxTabs.vue?vue&type=template&id=588a1c94&lang=html", function () {
      api.rerender('588a1c94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vx-tabs/VxTabs.vue"
export default component.exports